import { css } from '@microsoft/fast-element';
import { getToken } from '../../design-tokens';

export const hamburgerButtonStyles = css`
    .overlay {
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
    }

    .nav-button {
        fill: ${getToken('color-primary-base')};
        color: ${getToken('color-primary-base')};
        width: calc(${getToken('space-design-unit')} * 6px);
    }

    .nav-button svg {
        width: 100%;
    }

    :host(.opened) .overlay {
        display: initial;
    }
`;
